import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { PaymentProvider } from "@/types/payment";

interface PaymentProviderSelectProps {
  value: PaymentProvider;
  onChange: (value: PaymentProvider) => void;
}

export function PaymentProviderSelect({ value, onChange }: PaymentProviderSelectProps) {
  return (
    <div className="space-y-4">
      <Label>Select Payment Provider</Label>
      <RadioGroup
        value={value}
        onValueChange={(value) => onChange(value as PaymentProvider)}
        className="space-y-2"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="mtn" id="mtn" />
          <Label htmlFor="mtn">MTN Mobile Money</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="airtel" id="airtel" />
          <Label htmlFor="airtel">Airtel Money</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="orange" id="orange" />
          <Label htmlFor="orange">Orange Money</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="vodafone" id="vodafone" />
          <Label htmlFor="vodafone">Vodafone Cash</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="paystack" id="paystack" />
          <Label htmlFor="paystack">Bank Account (Paystack)</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="paypal" id="paypal" />
          <Label htmlFor="paypal">PayPal</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="crypto" id="crypto" />
          <Label htmlFor="crypto">Cryptocurrency</Label>
        </div>
      </RadioGroup>
    </div>
  );
}